module.exports = __webpack_public_path__ + "img/jiantou.2761b6c4.gif";